import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paytm-logo',
  templateUrl: './paytm-logo.component.html',
  styleUrls: ['./paytm-logo.component.scss']
})
export class PaytmLogoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
